import React, { createContext, useContext, useEffect, useState } from "react";
import { content } from "../lib/content";

// Global site settings (booking link, socials, tagline). Fetched client-side after
// mount; every consumer passes a built-in fallback, so SSR and the first client
// render use the defaults and there's no hydration mismatch. Overridden values
// (set in admin) swap in once loaded.
const SettingsContext = createContext<Record<string, string>>({});

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<Record<string, string>>({});
  useEffect(() => {
    content.settings().then(setSettings).catch(() => setSettings({}));
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

/** Returns the admin-set value for `key`, or `fallback` when unset/empty. */
export function useSetting(key: string, fallback: string): string {
  const settings = useContext(SettingsContext);
  return settings[key] || fallback;
}
